































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DemoServer from "../../shared/DemoServer";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";

import UserJson from "../../shared/UserJson";
import BirthdayBookingJson from "../../shared/BirthdayBookingJson";
import BirthdayBookingWithOverbookingInfoJson from "../../shared/BirthdayBookingJson";
import BirthdayProgramJson, { getBirthdayProgramsGrouped } from "../../shared/BirthdayProgramJson";
import { BirthdayBookingStaffAssignmentJson } from "../../shared/BirthdayBookingJson";
import { BirthdayBookingLocationAssignmentJson } from "../../shared/BirthdayBookingJson";

import { BirthdayBookingStatus } from "../../shared/BirthdayBookingStatus";
import { Gender } from "../../shared/Gender";
import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { validateBirthdayBookingJsonManagement } from "../../shared/BirthdayBookingJson";
import { validateBirthdayBookingJsonManagementAdd } from "../../shared/BirthdayBookingJson";
import { ValidationResult, Validation } from "../../shared/Validation";
import BirthdayStaffAvailableJson from "../../shared/BirthdayStaffAvailableJson";
import BirthdayBookingInfoJson from "../../shared/BirthdayBookingInfoJson";
import CustomerJson, { defaultCustomerJson } from "../../shared/CustomerJson";
import SepaMandateJson from "../../shared/SepaMandateJson";

import InvoiceInfoDetails from "../general/InvoiceInfoDetails.vue";

type keysForCachedPrices = {
  [key in keyof Pick<BirthdayBookingJson, "price" | "cancellationFee">]: string;
};

export default Vue.extend({
  name: "BirthdaysBirthdayDetails",
  components: {
    OverlayWindow,
    Loading,
    InvoiceInfoDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    BirthdayBookingStatusNames: Object,
    defaultBirthdayDetails: Object,
    birthdayId: Number,
    mode: String,
  },
  data() {
    return {
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      getBirthdayProgramsGrouped: getBirthdayProgramsGrouped,
      supportsDatePicker: false,
      editable: false as boolean,
      detailsTitle: "",
      allUsers: null as UserJson[] | null,
      availableStaff: null as BirthdayStaffAvailableJson[] | null,
      allBirthdayPrograms: null as BirthdayProgramJson[] | null,
      birthdayBookingInfo: null as BirthdayBookingInfoJson | null,
      Gender: Gender,
      genderNames: {
        male: "männlich",
        female: "weiblich",
        other: "divers",
      },
      BirthdayBookingStatus: BirthdayBookingStatus,
      UserPermissionRank: UserPermissionRank,
      availableLocations: null as { [index: string]: boolean } | null,
      detailsMode: "",
      selectedBirthdayId: null as number | null,
      birthdayDetails: null as BirthdayBookingWithOverbookingInfoJson | null,
      selectedBirthdayProgramId: null as number | null,
      cachedBeginDate: "" as string,
      cachedBirthDate: "" as string,
      cachedPrices: {
        price: "0,00",
        cancellationFee: "0,00",
      } as keysForCachedPrices,
      simultanousCount: null as object | null | string,
      simultaneousProgramCount: null as object | null | string,
      useSepaMandate: false as boolean,
      hasChanges: false,
      hintChanged: {
        timeSlotOverbooked: false as boolean,
        programOverbooked: false as boolean,
        program: false as boolean,
        staff: false as boolean,
        restrictStaff: false as boolean,
        estimatedChildrenCount: false as boolean,
      },
      toValidate: [] as string[],
      validation: null as ValidationResult<BirthdayBookingJson> | null,
      submitValidation: false as boolean,
      loadingNextup: false as boolean,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.initBirthdaysBirthdayDetails();
  },
  mounted() {
    this.checkDatePickerSupport();
    this.setCachedData();
  },
  methods: {
    initBirthdaysBirthdayDetails() {
      this.selectedBirthdayId = this.birthdayId;

      this.loadBirthdayPrograms();
      this.loadBirthdayDetails();
      this.selectDetailsMode(this.mode);
      this.loadAllUsers();

      if (this.permissionAble) {
        this.loadAvailableStaff();
      }
    },

    setCachedData() {
      this.setCachedBeginDate();
      this.setCachedBirthDate();
      this.setCachedPrices();
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadBirthdayDetails() {
      if (this.selectedBirthdayId != null) {
        try {
          this.birthdayDetails = await this.restClient.getBirthdayBooking(this.selectedBirthdayId);

          this.loadAvailableLocations();

          if (this.birthdayDetails.sepaMandate != null) {
            this.useSepaMandate = true;
          }

          this.findBirthdayProgramId();
        } catch (e) {
          alert(e.message);
        }
      } else {
        this.birthdayDetails = {
          ID: null,
          beginDateTime: "",
          endDateTime: "",
          remarks: "",
          customer: this.getDefaultCustomer(),
          state: BirthdayBookingStatus.requestedStaffRequired,
          isStaffRequired: true,
          staffId: null,
          restrictStaffAssignmentIds: null,
          programCategory: "",
          programTitle: "",
          programRemarks: "",
          location: "",
          estimatedChildrenCount: 1,
          price: null,
          cancellationFee: 0,
          cancellationRemarks: "",
          sepaMandate: null,
          invoiceInfos: null,
        };
      }

      this.setCachedData();
      this.hasChanges = false;
    },

    getDefaultCustomer(): CustomerJson {
      return defaultCustomerJson();
    },

    getDefaultSepaMandate(): SepaMandateJson {
      if (this.birthdayDetails != null) {
        return {
          ID: null,
          dateTime: new Date().toISOString(),
          lastUseDateTime: new Date().toISOString(),
          accountHolderFirstName: this.birthdayDetails.customer.guardianFirstName,
          accountHolderLastName: this.birthdayDetails.customer.guardianLastName,
          addressStreet: this.birthdayDetails.customer.addressStreet,
          addressZip: this.birthdayDetails.customer.addressZip,
          addressCity: this.birthdayDetails.customer.addressCity,
          addressCountry: this.birthdayDetails.customer.addressCountry,
          IBAN: "",
          BIC: "",
        };
      } else {
        return {
          ID: null,
          dateTime: new Date().toISOString(),
          lastUseDateTime: new Date().toISOString(),
          accountHolderFirstName: "",
          accountHolderLastName: "",
          addressStreet: "",
          addressZip: "",
          addressCity: "",
          addressCountry: "Deutschland",
          IBAN: "",
          BIC: "",
        };
      }
    },

    async reloadBirthdayDetails() {
      if (this.selectedBirthdayId != null) {
        this.birthdayDetails = null;
        try {
          this.birthdayDetails = await this.restClient.getBirthdayBooking(this.selectedBirthdayId);

          this.loadAvailableLocations();

          if (this.permissionAble) {
            this.loadAvailableStaff();
          }

          this.setCachedData();

          this.$nextTick(() => {
            this.hasChanges = false;
          });
        } catch (e) {
          alert(e.message);
        }
      }
    },

    toggleUseSepaMandate() {
      if (this.birthdayDetails != null) {
        if (this.useSepaMandate) {
          this.birthdayDetails.sepaMandate = null;
          this.useSepaMandate = false;
        } else {
          this.birthdayDetails.sepaMandate = this.getDefaultSepaMandate();
          this.useSepaMandate = true;
        }
      }
    },

    async loadAllUsers() {
      this.allUsers = null;
      if (this.restClient != null) {
        try {
          this.allUsers = await this.restClient.getUsers();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadAvailableStaff() {
      this.availableStaff = null;
      if (this.restClient != null) {
        try {
          this.availableStaff = await this.restClient.getBirthdayStaffAvailability(null);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadAvailableLocations() {
      this.availableLocations = null;
      if (
        this.restClient != null &&
        this.birthdayDetails &&
        this.birthdayDetails.beginDateTime.trim() != "" &&
        this.birthdayDetails.endDateTime.trim() != ""
      ) {
        try {
          this.availableLocations = await this.restClient.getBirthdayBookingEventLocationAvailability(
            new Date(this.birthdayDetails.beginDateTime),
            new Date(this.birthdayDetails.endDateTime),
            this.birthdayDetails.ID
          );
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadBirthdayPrograms() {
      this.allBirthdayPrograms = null;

      try {
        this.allBirthdayPrograms = await this.restClient.getBirthdayPrograms();
      } catch (e) {
        alert(e.message);
      }
    },

    /* async loadBirthdayBookingInfo() {
      this.availablePrograms = null;
      this.birthdayBookingInfo = null;
      if (this.restClient != null) {
        try {
          let rc = RestClient;
          this.birthdayBookingInfo = await rc.getBirthdayBookingInfo();
          this.availablePrograms = this.birthdayBookingInfo.availablePrograms;
        } catch (e) {
          alert(e.message);
        }
      }

      //this.findBirthdayProgramId()
    }, */

    selectDetailsMode(mode: string) {
      this.resetHintChanged();

      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Geburtstag hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Geburtstag bearbeiten";
          this.editable = true;
          this.loadAvailableLocations();
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Geburtstag";
          this.editable = false;
          break;
      }
    },

    resetHintChanged() {
      let k = this.hintChanged;
      let i: keyof typeof k;

      for (i in this.hintChanged) {
        this.hintChanged[i] = false;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        //todo: use $refs
        //fliegt viell. komplett raus wegen reload
        document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
        this.selectDetailsMode("show");
        this.reloadBirthdayDetails();
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          document.getElementsByClassName("overlay-window-scroll")[0].scrollTo(0, 0);
          this.selectDetailsMode("show");
          this.reloadBirthdayDetails();
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(input: string) {
      this.toValidate.push(input);

      if (this.birthdayDetails != null) {
        this.validation = validateBirthdayBookingJsonManagement(this.birthdayDetails);
      }
    },

    removeValidationHint(input: string) {
      let index = this.toValidate.indexOf(input);

      if (index >= 0) {
        this.toValidate.splice(index, 1);
      }
    },

    //START set cached data

    setCachedBeginDate() {
      if (this.birthdayDetails != null && this.birthdayDetails.beginDateTime != "") {
        if (this.supportsDatePicker) {
          let d = new Date(this.birthdayDetails.beginDateTime);

          this.cachedBeginDate = DateFormatter.formatISODate(d);
        } else {
          let d = new Date(this.birthdayDetails.beginDateTime);

          if (d != null) {
            this.cachedBeginDate = DateFormatter.formatDateMedium(d);
          }
        }
      }
    },

    setCachedBirthDate() {
      if (
        this.birthdayDetails != null &&
        this.birthdayDetails.customer != null &&
        this.birthdayDetails.customer.childBirthDate != ""
      ) {
        if (this.supportsDatePicker) {
          this.cachedBirthDate = this.birthdayDetails.customer.childBirthDate!;
        } else {
          let d = new Date(this.birthdayDetails.customer.childBirthDate!);

          if (d != null) {
            this.cachedBirthDate = DateFormatter.formatDateMedium(d);
          }
        }
      }
    },

    setCachedPrices() {
      if (this.birthdayDetails != null) {
        let k = this.cachedPrices;
        let i: keyof typeof k;

        for (i in this.cachedPrices) {
          let price = this.birthdayDetails[i]
            ?.toString()
            .padStart(3, "0")
            .replace(/(\d{2,2})$/g, ",$1")
            .replace("NaN", "");

          if (price !== undefined) {
            this.cachedPrices[i] = price;
          }
        }
      }
    },

    //END set cached data

    //START set input data (where data be cached)

    setBeginDate() {
      if (this.birthdayDetails != null) {
        var beginDate = "";

        if (this.supportsDatePicker) {
          beginDate = DateFormatter.formatUSDate(new Date(this.cachedBeginDate));
        } else {
          if (this.cachedBeginDate.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedBeginDate);

            if (d != null) {
              beginDate = DateFormatter.formatUSDate(d);
            }
          }
        }

        if (isNaN(new Date(beginDate).getTime())) {
          this.birthdayDetails.beginDateTime = "";
          this.birthdayDetails.endDateTime = "";
        } else {
          //beginDateTime
          var beginDateTime = new Date(beginDate);

          if (this.birthdayDetails.beginDateTime != "") {
            let beginTime = DateFormatter.formatTime(new Date(this.birthdayDetails.beginDateTime));

            beginDateTime = new Date(beginDate + " " + beginTime);
          }

          this.birthdayDetails.beginDateTime = DateFormatter.formatISODateTime(beginDateTime);

          //endDateTime
          if (this.birthdayDetails.endDateTime != "") {
            let endTime = DateFormatter.formatTime(new Date(this.birthdayDetails.endDateTime));
            let endBirthDate = new Date(beginDate + " " + endTime);

            this.birthdayDetails.endDateTime = DateFormatter.formatISODateTime(endBirthDate);
          }
        }
      }
    },

    setBirthDate() {
      if (this.birthdayDetails != null && this.birthdayDetails.customer != null) {
        var birthDate = "";

        if (this.supportsDatePicker) {
          birthDate = this.cachedBirthDate;
        } else {
          if (this.cachedBirthDate.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
            let d = DateFormatter.parseDateString(this.cachedBirthDate);

            if (d != null) {
              birthDate = DateFormatter.formatISODate(d);
            }
          }
        }

        this.birthdayDetails.customer.childBirthDate = birthDate;
      }
    },

    formatAndSetCachedPrices(key: keyof keysForCachedPrices) {
      if (this.birthdayDetails != null) {
        let price = this.cachedPrices[key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedPrices[key] = price;
        this.birthdayDetails[key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    //END set input data

    async addNewBirthday() {
      if (this.birthdayDetails != null) {
        this.loadingGeneral = true;

        this.validation = validateBirthdayBookingJsonManagementAdd(this.birthdayDetails);

        this.submitValidation = true;

        if (this.validation != null && this.validation.isValid == true) {
          try {
            this.birthdayDetails = await this.restClient.addBirthday(this.birthdayDetails);
            alert("Der Geburtstag wurde erfolgreich hinzugefügt.");
            this.$nextTick(() => {
              if (this.birthdayDetails != null) {
                this.selectedBirthdayId = this.birthdayDetails.ID;
              }

              this.hasChanges = false;
              this.loadingGeneral = false;
              this.stopEditMode();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Der Geburtstag konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    /*
    async saveBirthdayDetails() {
      if (this.birthdayDetails != null) {
        if (this.hasChanges) {
          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateBirthdayBookingJsonManagement(
            this.birthdayDetails
          )
          //todo ###END
          if (this.validation != null && this.validation.isValid == true) {
            if (this.restClient != null) {
              try {
                let updatedBirthdayDetails = await this.restClient.updateBirthday(
                  this.birthdayDetails
                )

                this.hasChanges = false
                this.stopEditMode()

                //TODO: Validation error loest alert auch aus -> prüfen
                alert("Die Änderungen wurden erfolgreich gespeichert.")
              } catch (e) {
                alert(e.message)
              }
            }
          } else {
            alert(
              "Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen."
            )
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.")
        }
      }
    },
    */

    async saveBirthdayDetails() {
      if (this.birthdayDetails != null) {
        this.loadingGeneral = true;

        //todo ###START
        //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
        this.validation = validateBirthdayBookingJsonManagement(this.birthdayDetails);
        //todo ###END
        if (this.validation != null && this.validation.isValid == true) {
          if (this.restClient != null) {
            try {
              let updatedBirthdayDetails = await this.restClient.updateBirthday(this.birthdayDetails);

              this.hasChanges = false;
              this.loadingGeneral = false;

              //TODO: Validation error loest alert auch aus -> prüfen
              alert("Die Änderungen wurden erfolgreich gespeichert.");

              return true;
            } catch (e) {
              this.loadingGeneral = false;
              alert(e.message);
              return false;
            }
          }
        } else {
          this.loadingGeneral = false;
          alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          return false;
        }
      }
    },

    async saveBirthday() {
      if (this.hasChanges) {
        if (await this.saveBirthdayDetails()) {
          this.stopEditMode();
        }
      } else {
        alert("Es wurden keine Änderungen vorgenommen.");
      }
    },

    async deleteBirthday() {
      if (this.birthdayDetails != null) {
        let c = confirm("Wollen Sie diesen Geburtstag wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteBirthday(this.birthdayDetails);
              this.closeDetails();
              alert("Der Geburtstag wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    async cancelBirthday() {
      if (!this.hasChanges) {
        if (this.birthdayDetails != null && this.birthdayDetails.ID != null) {
          let c = confirm(
            "Wollen Sie die Absage per E-Mail bestätigen? Der Geburtstag wird unter Berücksichtigung der Stornierungsgebühr (€ " +
              this.getFormatPrice(this.birthdayDetails.cancellationFee) +
              ") abgesagt. Bereits zugeteilte Betreuer:innen werden automatisch informiert."
          );
          if (c == true) {
            this.loadingGeneral = true;

            if (this.restClient != null) {
              try {
                await this.restClient.cancelBirthday(this.birthdayDetails.ID);
                this.closeDetails();
                alert("Der Geburtstag wurde erfolgreich abgesagt.");

                this.loadingGeneral = false;
              } catch (e) {
                alert(e.message);

                this.loadingGeneral = false;
              }
            }
          } else {
            //do nothing
          }
        }
      } else {
        alert("Bitte speichern Sie zuvor die letzten Änderungen.");
      }
    },

    /* async confirmCancellation() {
         if (!this.hasChanges) {
            if (this.birthdayDetails != null && this.birthdayDetails.ID != null) {
               this.loadingGeneral = true

               if (this.restClient != null) {
                  try {
                     await this.restClient.confirmBirthdayCancellation(this.birthdayDetails.ID)
                     this.closeDetails()
                     alert("Die Stornierung wurde erfolgreich bestätigt.")

                     this.loadingGeneral = false
                  } catch (e) {
                     alert(e.message)

                     this.loadingGeneral = false
                  }
               }
            }
         } else {
            alert("Bitte speichern Sie zuvor die letzten Änderungen.")
         }
      }, */

    async assignStaffToBirthday() {
      if (this.hasChanges) {
        await this.saveBirthdayDetails();
      }

      if (this.birthdayDetails != null) {
        if (this.birthdayDetails.staffId != null) {
          if (this.restClient != null) {
            var staffDetails = {
              ID: this.birthdayDetails.ID,
              staffId: this.birthdayDetails.staffId,
            } as BirthdayBookingStaffAssignmentJson;
            try {
              await this.restClient.assignBirthdayStaff(staffDetails);
              alert("Der oder die Betreuer:in wurde erfolgreich zugewiesen.");
              this.hasChanges = false;
              this.stopEditMode();
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          alert("Es ist kein:e Betreuer:in ausgewählt.");
        }
      }
    },

    async sendNoStaffAvailableMessage() {
      if (this.birthdayDetails != null && this.birthdayDetails.ID != null) {
        this.loadingNextup = true;

        try {
          await this.restClient.sendBirthdayNoStaffMessageToCustomer(this.birthdayDetails.ID);
          alert("Der oder die Buchende wurde per E-Mail benachrichtigt.");

          this.loadingNextup = false;
          this.stopEditMode();
        } catch (e) {
          this.loadingNextup = false;
          alert(e.message);
        }
      }
    },

    async sendBirthdayOffer() {
      if (this.hasChanges) {
        await this.saveBirthdayDetails();
      }

      if (this.birthdayDetails != null) {
        this.loadingNextup = true;

        if (
          !this.birthdayDetails.isStaffRequired ||
          (this.birthdayDetails.isStaffRequired && this.birthdayDetails.staffId != null)
        ) {
          if (this.restClient != null) {
            var offerDetails = {
              ID: this.birthdayDetails.ID,
              location: this.birthdayDetails.location,
              price: this.birthdayDetails.price,
            } as BirthdayBookingLocationAssignmentJson;

            try {
              await this.restClient.sendBirthdayOfferToCustomer(offerDetails);
              alert("Es wurde eine Bestätigung an den oder die Buchende gesendet.");
              this.hasChanges = false;

              this.loadingNextup = false;
              this.stopEditMode();
            } catch (e) {
              this.loadingNextup = false;
              alert(e.message);
            }
          }
        } else {
          this.loadingNextup = false;
          alert("Es muss ein:e Betreuer:in zugeteilt werden, bevor eine Benachrichtigung gesendet werden kann.");
        }
      }
    },

    findBirthdayProgramId() {
      if (this.birthdayDetails != null && this.allBirthdayPrograms != null) {
        let selectedProgramId = null;

        selectedProgramId = this.allBirthdayPrograms.find(
          (program: BirthdayProgramJson) => program.title == this.birthdayDetails?.programTitle
        )?.ID;

        if (selectedProgramId !== undefined) {
          this.selectedBirthdayProgramId = selectedProgramId;
        }
      }
    },

    updateBirthdayProgram() {
      if (this.birthdayDetails != null && this.allBirthdayPrograms != null) {
        let selectedProgram = null;

        selectedProgram = this.allBirthdayPrograms.find(
          (program: BirthdayProgramJson) => program.ID == this.selectedBirthdayProgramId
        );

        if (selectedProgram != null && selectedProgram !== undefined) {
          this.birthdayDetails.programTitle = selectedProgram.title;
          this.birthdayDetails.programCategory = selectedProgram.category;
          this.birthdayDetails.programRemarks = selectedProgram.remarks;
          this.birthdayDetails.restrictStaffAssignmentIds = selectedProgram.restrictStaffAssignmentIds;

          if (this.detailsMode == "add") {
            this.birthdayDetails.cancellationFee = selectedProgram.cancellationFee;
            this.birthdayDetails.cancellationRemarks = selectedProgram.cancellationRemarks;
            this.setCachedPrices();
          }
        }
      }
    },

    async checkTimeSlotOverbooking() {
      this.simultanousCount = "loading";

      if (
        this.birthdayDetails != null &&
        this.birthdayDetails.beginDateTime != "" &&
        this.birthdayDetails.endDateTime != ""
      ) {
        try {
          let simultanousCount = await this.restClient.getBirthdaySimultanousCount(
            new Date(this.birthdayDetails.beginDateTime),
            new Date(this.birthdayDetails.endDateTime),
            this.selectedBirthdayId
          );

          if (simultanousCount.countSimultanous >= simultanousCount.maxCountSimultanous) {
            this.hintChanged.timeSlotOverbooked = true;
          } else {
            this.hintChanged.timeSlotOverbooked = false;
          }

          this.simultanousCount = simultanousCount;
        } catch (e) {
          alert(e.message);
        }
      } else {
        this.simultanousCount = null;
        this.hintChanged.timeSlotOverbooked = false;
      }
    },

    async checkProgramOverbooking() {
      this.simultaneousProgramCount = "loading";

      if (
        this.birthdayDetails != null &&
        this.birthdayDetails.beginDateTime != "" &&
        this.birthdayDetails.endDateTime != "" &&
        this.birthdayDetails.programCategory != "" &&
        this.birthdayDetails.programTitle != ""
      ) {
        try {
          let simultaneousProgramCount = await this.restClient.getBirthdaySimultaneousProgramCount(
            new Date(this.birthdayDetails.beginDateTime),
            new Date(this.birthdayDetails.endDateTime),
            this.birthdayDetails.programCategory,
            this.birthdayDetails.programTitle,
            this.selectedBirthdayId
          );

          if (
            simultaneousProgramCount.maxSimultaneousProgramCount !== null &&
            simultaneousProgramCount.simultaneousProgramCount >= simultaneousProgramCount.maxSimultaneousProgramCount
          ) {
            this.hintChanged.programOverbooked = true;
          } else {
            this.hintChanged.programOverbooked = false;
          }

          this.simultaneousProgramCount = simultaneousProgramCount;
        } catch (e) {
          alert(e.message);
        }
      } else {
        this.simultaneousProgramCount = null;
        this.hintChanged.programOverbooked = false;
      }
    },

    checkStaffWithProgram() {
      if (this.birthdayDetails != null) {
        if (this.birthdayDetails.restrictStaffAssignmentIds != null) {
          if (
            this.birthdayDetails.staffId != null &&
            this.birthdayDetails.restrictStaffAssignmentIds.indexOf(this.birthdayDetails.staffId) < 0
          ) {
            this.hintChanged.restrictStaff = true;
          } else {
            this.hintChanged.restrictStaff = false;
          }
        } else {
          this.hintChanged.restrictStaff = false;
        }
      }
    },

    // print
    printBookingDetails() {
      var toPrint = document.getElementById("toPrint");

      if (toPrint != null) {
        var eles = this.$el.querySelectorAll(".print-view");

        for (let i = 0; i < eles.length; i++) {
          toPrint.appendChild(eles[i].cloneNode(true));
        }
      }

      this.$nextTick(() => {
        window.print();
      });

      this.$nextTick(() => {
        while (toPrint?.lastElementChild) {
          toPrint.removeChild(toPrint.lastElementChild);
        }
      });
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    birthdayDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    nextupEditable: function () {
      if (this.birthdayDetails != null) {
        let nextupStates = [this.BirthdayBookingStatus.requestedPendingConfirmation];

        if (this.detailsMode != "add" && nextupStates.indexOf(this.birthdayDetails.state) >= 0) {
          return true;
        } else {
          return false;
        }
      }
    },

    availableStaffForBirthday: function (): any[] {
      var staff: any[] = [];

      if (this.availableStaff != null && this.birthdayDetails != null && this.allUsers != null) {
        if (this.birthdayDetails.beginDateTime != "") {
          let selectedDate = new Date(this.birthdayDetails.beginDateTime);
          let availableForBirthday = this.availableStaff.filter(
            (i) => new Date(i.beginDateTime).getTime() == selectedDate.getTime() && i.status == "open"
          );

          for (let i = 0; i < availableForBirthday.length; i++) {
            staff.push(this.allUsers.find((user: UserJson) => user.ID == availableForBirthday[i].staffId));
          }
        }
      }

      return staff;
    },

    formatDateTime: {
      get(): string | undefined {
        if (this.birthdayDetails != null) {
          if (this.supportsDatePicker) {
            let d = new Date(this.birthdayDetails.beginDateTime);
            return DateFormatter.formatISODate(d);
          } else {
            if (this.birthdayDetails.beginDateTime != "") {
              let d = new Date(this.birthdayDetails.beginDateTime);
              let date = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
              let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
              return date + "." + month + "." + d.getFullYear();
            }
          }
        }
      },
      set(value: string) {
        if (this.birthdayDetails != null) {
          var beginDate = "";

          if (this.supportsDatePicker) {
            beginDate = DateFormatter.formatUSDate(new Date(value));
          } else {
            if (value.match(/^\d{1,2}.\d{1,2}.\d{4}$/g)) {
              let d = DateFormatter.parseDateString(value);

              if (d != null) {
                beginDate = DateFormatter.formatUSDate(d);
              }
            }
          }

          if (isNaN(new Date(beginDate).getTime())) {
            this.birthdayDetails.beginDateTime = "";
            this.birthdayDetails.endDateTime = "";
          } else {
            //beginDateTime
            var beginDateTime = new Date(beginDate);

            if (this.birthdayDetails.beginDateTime != "") {
              let beginTime = DateFormatter.formatTime(new Date(this.birthdayDetails.beginDateTime));

              beginDateTime = new Date(beginDate + " " + beginTime);
            }

            this.birthdayDetails.beginDateTime = DateFormatter.formatISODateTime(beginDateTime);

            //endDateTime
            if (this.birthdayDetails.endDateTime != "") {
              let endTime = DateFormatter.formatTime(new Date(this.birthdayDetails.endDateTime));
              let endBirthDate = new Date(beginDate + " " + endTime);

              this.birthdayDetails.endDateTime = DateFormatter.formatISODateTime(endBirthDate);
            }
          }
        }
      },
    },

    formatBeginTime: {
      get(): string | undefined {
        if (this.birthdayDetails != null) {
          let d = new Date(this.birthdayDetails.beginDateTime);
          let time = DateFormatter.formatTime(d);
          if (time == "unbekannt") {
            return "";
          } else {
            return DateFormatter.formatTime(d);
          }
        }
      },
      set(value: string) {
        let time = value.replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

        if (this.birthdayDetails != null && time.match(/^\d{2,2}:\d{2,2}$/g)) {
          if (this.birthdayDetails.beginDateTime != "") {
            let date = DateFormatter.formatUSDate(new Date(this.birthdayDetails.beginDateTime));
            this.birthdayDetails.beginDateTime = DateFormatter.formatISODateTime(new Date(date + " " + time));
          }
        }
      },
    },

    formatEndTime: {
      get(): string | undefined {
        if (this.birthdayDetails != null) {
          let d = new Date(this.birthdayDetails.endDateTime);
          let time = DateFormatter.formatTime(d);
          if (time == "unbekannt") {
            return "";
          } else {
            return DateFormatter.formatTime(d);
          }
        }
      },
      set(value: string) {
        let time = value.replace(/\D/g, "").replace(/^(\d{2,2})/g, "$1:");

        if (this.birthdayDetails != null && time.match(/^\d{2,2}:\d{2,2}$/g)) {
          if (this.birthdayDetails.beginDateTime != "") {
            let date = DateFormatter.formatUSDate(new Date(this.birthdayDetails.beginDateTime));
            this.birthdayDetails.endDateTime = DateFormatter.formatISODateTime(new Date(date + " " + time));
          }
        }
      },
    },

    getStaff: function (): UserJson | undefined | null {
      if (this.allUsers != null) {
        return this.allUsers.find((item: UserJson) => {
          if (this.birthdayDetails != null) {
            return item.ID == this.birthdayDetails.staffId;
          }
        });
      }
    },

    parseEstimatedChildrenCount: {
      get(): number | undefined {
        if (this.birthdayDetails != null) {
          return this.birthdayDetails.estimatedChildrenCount;
        }
      },
      set(value: string) {
        if (this.birthdayDetails != null) {
          this.birthdayDetails.estimatedChildrenCount = parseInt(value);
        }
      },
    },

    formatIBAN: {
      get(): string | undefined {
        if (this.birthdayDetails != null) {
          if (this.birthdayDetails.sepaMandate != null) {
            return this.birthdayDetails.sepaMandate.IBAN.toUpperCase()
              .replace(/[^0-9A-Z]/g, "")
              .replace(/(.{1,4})/g, "$1 ")
              .trim();
          }
        }
      },
      set(value: string) {
        if (this.birthdayDetails != null) {
          if (this.birthdayDetails.sepaMandate != null) {
            this.birthdayDetails.sepaMandate.IBAN = value;
          }
        }
      },
    },
  },
});
